export default __webpack_public_path__ + "static/media/fwactiontwo.6dcc893b.png";